<template>
<a href="/mine/message/index.html" :class="current" :data-scp="scp" v-show="showInAndroid">
	<i class="icon icon-advice"></i><span>消息</span>
</a>
</template>
<script>
import maple from 'maple';
import app from 'app';
export default {
	props: ['current', 'scp'],
	data:function(){
		/**
		 * android-app在20161221以前的版本点击消息跳转后的页面如果未登录会崩溃所以在旧版的APP下隐藏消息按钮
		 */
		return {
			showInAndroid:!(maple.cookie('global')==='android'&&app.getTgAppVersion()<20161221)
		}
	}
}
</script>